export default "__VITE_ASSET__CqLvrIba__"